import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router";
import DesktopHeader from "./components/DesktopHeader";
import DesktopFooter from "./components/DesktopFooter";
import MobileHeader from "./components/MobileHeader";
import MobileFooter from "./components/MobileFooter";
import Home from "./pages/Home";
import MobileMenu from "./components/MobileMenu";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import { ToastContainer } from "react-toastify";
import ScrollToTop from "./components/ScrollToTop";
import Services from "./pages/Services";
import Register from "./pages/Register";
import Privacy from "./pages/Privacy";
import DataPrivacy from "./pages/DataPrivacy";

const App = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  useEffect(() => {
    if (isMenuOpen) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
  }, [isMenuOpen]);

  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        <div
          className={`flex ${isMenuOpen && "overscroll-none"} min-h-screen w-screen flex-col justify-between`}
        >
          <DesktopHeader />
          {isMenuOpen && <MobileMenu />}
          <MobileHeader setIsMenuOpen={setIsMenuOpen} isMenuOpen={isMenuOpen} />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/register" element={<Register />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/data-policy" element={<DataPrivacy />} />
          </Routes>
          <DesktopFooter />
          <MobileFooter />
        </div>
      </BrowserRouter>
      <ToastContainer />
    </>
  );
};

export default App;
